import { TreeItem, TreeviewItem } from '@ingenmaffen/ngx-treeview';

export class CustomTreeviewItem extends TreeviewItem {
  constructor(item: TreeItem, autoCorrectChecked?: boolean) {
    super(item, autoCorrectChecked);
  }

  getSelection() {
    const items = super.getSelection();
    if (this.checked && this.children) {
      items.checkedItems.push(this);
    } else {
      items.uncheckedItems.push(this);
    }
    return items;
  }
}
